var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-openeds":[],"background-color":"#006bb2","text-color":"#ffffff","active-text-color":"#ffffff"}},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.loginSidebar,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }